/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BackgroundJobPayloadForPeriodicAwsSsmAutomationExecutionProgress extends models.PeriodicBackgroundJobPayloadBase {
    constructor() {
        super();
        this.setDiscriminator("BackgroundJobPayloadForPeriodicAwsSsmAutomationExecutionProgress");
    }

    getFixupPrototypeFunction() { return BackgroundJobPayloadForPeriodicAwsSsmAutomationExecutionProgress.fixupPrototype; }

    static newInstance(model: Partial<BackgroundJobPayloadForPeriodicAwsSsmAutomationExecutionProgress>): BackgroundJobPayloadForPeriodicAwsSsmAutomationExecutionProgress {
        let obj = Object.assign(new BackgroundJobPayloadForPeriodicAwsSsmAutomationExecutionProgress(), model);
        BackgroundJobPayloadForPeriodicAwsSsmAutomationExecutionProgress.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BackgroundJobPayloadForPeriodicAwsSsmAutomationExecutionProgress>): BackgroundJobPayloadForPeriodicAwsSsmAutomationExecutionProgress {
        if (!model) return null;
        return BackgroundJobPayloadForPeriodicAwsSsmAutomationExecutionProgress.newInstance(<BackgroundJobPayloadForPeriodicAwsSsmAutomationExecutionProgress> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BackgroundJobPayloadForPeriodicAwsSsmAutomationExecutionProgress) {
        if (!obj) return;

        models.BackgroundJobPayloadForPeriodicAwsSsmAutomationExecutionProgress.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BackgroundJobPayloadForPeriodicAwsSsmAutomationExecutionProgress): boolean {
        if (models.PeriodicBackgroundJobPayloadBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, BackgroundJobPayloadForPeriodicAwsSsmAutomationExecutionProgress.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
